import { render, staticRenderFns } from "./r-trader-order-dialog.vue?vue&type=template&id=7eb2c105&scoped=true"
import script from "./r-trader-order-dialog.vue?vue&type=script&lang=js"
export * from "./r-trader-order-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-trader-order-dialog.vue?vue&type=style&index=0&id=7eb2c105&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb2c105",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eb2c105')) {
      api.createRecord('7eb2c105', component.options)
    } else {
      api.reload('7eb2c105', component.options)
    }
    module.hot.accept("./r-trader-order-dialog.vue?vue&type=template&id=7eb2c105&scoped=true", function () {
      api.rerender('7eb2c105', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trader/r-trader-order-dialog.vue"
export default component.exports